import React from 'react'
import ReactDOM from 'react-dom'
import './index.scss'
import { BrowserRouter as Router } from 'react-router-dom'
import AuthStateApp from './App'

ReactDOM.render(
  <Router>
    <AuthStateApp />
  </Router>,
  document.getElementById('root')
)
